import memoize from 'memoize-one';
import { distanceBetweenPoints, rotatePoint } from '@bfly/utils/math';
import * as Intersect from './intersect';
export function splice(array, idx, ...rest) {
  if (idx >= array.length) throw new Error(`Item at index ${idx} does exist in ${array}`);
  const nextArray = [...array];
  nextArray.splice(idx, 1, ...rest);
  return nextArray;
}
export const checkValidPolygon = memoize((points, modifyingIndex) => {
  if (points.length < 3) return true;
  const last = points[points.length - 1];
  if (modifyingIndex !== -1) return !Intersect.modify(points, modifyingIndex);
  if (last === points[0]) return !Intersect.end(points);
  return !Intersect.newHandle(last, points.slice(0, -1));
});
export function shouldSnapToStartPoint(points, snapRadius = 10) {
  // We need to have at least 3 existing points to ensure polygonal contour.
  if (!points || points.length < 3) return false;
  return distanceBetweenPoints(points[0], points[points.length - 1]) <= snapRadius;
}
export function checkTraceDone(points, closedShape = false, numPoints = 2) {
  let donePoints = null;

  if (closedShape) {
    if (shouldSnapToStartPoint(points)) {
      // For new shapes we remove the pending point to close it
      donePoints = [...points.slice(0, -1)];
    }
  } else if (numPoints === 1) {
    donePoints = points.slice(-1); // zero is unbounded
  } else if (numPoints !== 0) {
    if (points.length >= numPoints) {
      // Just in case we somehow ended up with extra points.
      donePoints = [...points].slice(0, numPoints);
    }
  }

  return donePoints;
}
export function getBoundingCorners({
  width,
  height,
  rotation,
  center: [cx, cy]
}) {
  const c = [cx, cy];
  const rx = width / 2;
  const ry = height / 2;
  let topLeft = [cx - rx, cy - ry];
  let topRight = [cx + rx, topLeft[1]];
  let bottomRight = [topRight[0], cy + ry];
  let bottomLeft = [topLeft[0], bottomRight[1]];

  if (rotation) {
    topLeft = rotatePoint(topLeft, rotation, c);
    topRight = rotatePoint(topRight, rotation, c);
    bottomRight = rotatePoint(bottomRight, rotation, c);
    bottomLeft = rotatePoint(bottomLeft, rotation, c);
  }

  return {
    topLeft,
    topRight,
    bottomRight,
    bottomLeft
  };
}